import styled from 'styled-components'

const ContainerStyle = styled.div.attrs({})`
	width: 100%;
	margin: 0 auto;

	&:not(.full) {
		width: 100%;
		padding-left: var(--contPaddingLR);
		padding-right: var(--contPaddingLR);
	}

	&.first-section {
		margin-top: var(--sectionDistance);
	}

	&.section {
		margin-bottom: var(--sectionDistance);
	}

	&.full {
		padding-left: 0;
		padding-right: 0;
	}
`
export default ContainerStyle
